// extracted by mini-css-extract-plugin
export default {"link":"DD-z","disabled":"ED-z"};